import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SharedModule } from 'app/shared';
import { FeatureBundle, Subscription } from 'app/shared/service/subscriptions.model';
import { SupportService } from 'app/shared/support/support.service';
import { OverlayRef } from 'app/shared/ui/overlays';


@Component({
    selector: 'view-details-subscriptions',
    imports: [
        CurrencyPipe,
        DatePipe,
        SharedModule,
    ],
    template: `
        <ui-modal size="md">
            <modal-header>
                Subscriptions
            </modal-header>
            <modal-body class="p-4">
                <div class="row">
                    <div class="col">
                        @for (subscription of subscriptions; track subscription) {
                            <div>
                                <div class="row">
                                    <div class="col">
                                        <h5 class="d-inline-block mb-0">{{ getBundleName(subscription) }}</h5>
                                        <span class="price">
                                            <strong> - {{ subscription.price | currency:'USD':'symbol-narrow':'1.0-3' }}/{{ subscription.period }}
                                        </strong></span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <p class="mb-0 small" [class.text-warning]="!subscription.autoRenew">
                                            {{ subscription.autoRenew ? 'Subscription renews:' : 'Expiring' }} {{ subscription.expiryDate * 1000 | date: 'longDate' }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        Questions about your subscription(s)? <a tabindex (click)="openSupport()">Contact Us</a>
                    </div>
                </div>
            </modal-body>
            <modal-footer>
                <button class="btn btn-primary ml-auto" (click)="close()">
                    Close
                </button>
            </modal-footer>
        </ui-modal>
    `,
})
export class ViewDetailsSubscriptionsModalComponent {

    _originalSubscriptions: Subscription[];

    _subscriptions: Subscription[];

    @Input() set subscriptions(subscriptions: Subscription[]) {
        this._originalSubscriptions = subscriptions;
        this._subscriptions = subscriptions;
    }

    get subscriptions() {
        return this._subscriptions;
    }

    @Input() products: FeatureBundle[];

    constructor(
        private overlayRef: OverlayRef,
        private supportService: SupportService
    ) {}

    getBundleName(subscription: Subscription) {
        for (const bundle of this.products) {
            if (bundle.bundleId.monthly === subscription.planId || bundle.bundleId.yearly === subscription.planId) {
                return bundle.name;
            }
        }
        return subscription.name;
    }

    openSupport() {
        this.supportService.openSupport();
    }

    close() {
        this.overlayRef.dismiss('close');
    }
}
